import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { i18n } from '@lingui/core';
import { I18nProvider as I18nLinguiProvider } from '@lingui/react';

import { setupI18n } from './setup-i18n';

export type I18nLanguage = GLOBALS.Language;

type Props = {
  children: ReactNode;
  language: I18nLanguage;
};

export const I18nProvider = ({ language, children }: Props) => {
  // ensure i18n is setup for initial render
  setupI18n({ language });

  useEffect(() => {
    // handled synchronously above, but keeping for clarity and future async loads
    setupI18n({ language });
  }, [language]);

  return (
    <I18nLinguiProvider defaultComponent={({ children }) => <span>{children}</span>} i18n={i18n}>
      {children}
    </I18nLinguiProvider>
  );
};
